import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useThemeContext } from "../../../Context/ThemeContext";
import { DARKCOLORS, LIGHTCOLORS, ROUTES } from "../../../Utils/constants";
import WestIcon from "@mui/icons-material/West";
import {
  Box,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputBase,
  TextField,
  InputAdornment,
  LinearProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import ConfirmationModal from "../../../Components/Common/ConfirmationModal";
import { useLocation, useNavigate } from "react-router-dom";
import SuccessNotification from "../../../Components/Common/SuccessNotification";
import { showDatePicker } from "../../../Components/Common/StyledTextField";
import {
  addAdvertisement,
  getMachineLocations,
  updateAdvertisement,
  getAdvertisementsById,
  deleteAdvertisement,
} from "../../../Services/authService";
import SearchIcon from "@mui/icons-material/Search";
import LoadingAnimation from "../../../Components/Common/LoadingAnimation";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteConfirmationPopup from "../../../Components/Common/DeleteConfirmationPopup";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CalendarToday, Today } from "@mui/icons-material";

function AdvertisementModal() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { mode } = useThemeContext();
  const location = useLocation();

  const mode1 = location.state?.mode
    ? location.state?.mode
    : location.state?.referenceId
      ? "update"
      : "add";
  const adId = location.state?.referenceId || location.state?.advertisementId;

  // console.log("gg", mode1, location.state?.mode, location.state?.referenceId);
  const isMobile = useMediaQuery("(max-width:450px)");

  const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
  const [errors, setErrors] = useState({}); // Validation errors
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false); // Tracks if the form is modified
  const [isLoading, setIsLoading] = useState(false);
  const [successNotification, setSuccessNotification] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [locations, setLocations] = useState([]);
  const [filteredLocations, setFilteredLocations] = useState([]);
  const [selectedMachines, setSelectedMachines] = useState([]);
  const [advertisement, setAdvertisement] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [open1, setOpen1] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [generalError, setGeneralError] = useState("");

  const [videoUploads, setVideoUploads] = useState({
    vertical: { file: null, progress: 0 },
    horizontal: { file: null, progress: 0 },
    small: { file: null, progress: 0 },
  });
  const [uploading, setUploading] = useState(false);

  const [initialFormState, setInitialFormState] = useState({
    name: "",
    startDate: "",
    endDate: "",
    vendingMachineIds: [],
    videoUploads: [],
  });
  const [formData, setFormData] = useState(initialFormState);
  const textColor =
    mode === "dark"
      ? DARKCOLORS.BodyLightBackground
      : LIGHTCOLORS.BodyLightBackground;
  const dividerColor =
    mode === "dark" ? DARKCOLORS.Primary100 : LIGHTCOLORS.Primary100;
  const backgroundCard =
    mode === "dark" ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;
  const cardBorderColor40 =
    mode === "dark" ? DARKCOLORS.GreyScale40 : LIGHTCOLORS.GreyScale40;
  const inputBoxColor =
    mode === "dark" ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
  const blueColor =
    mode === "dark" ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;
  const errorTextColor =
    mode === "dark" ? DARKCOLORS.Danger500 : LIGHTCOLORS.Danger500;
  const scroll1 =
    mode === "light"
      ? LIGHTCOLORS.BodyDarkBackground
      : DARKCOLORS.BodyLightBackground;
  const scroll =
    mode === "light" ? LIGHTCOLORS.GreyScale40 : DARKCOLORS.GreyScale40;

  const CustomDeleteIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="17"
      viewBox="0 0 12 14"
      fill="none"
    >
      <path
        d="M11.5 3.48991C9.5575 3.29741 7.60333 3.19824 5.655 3.19824C4.5 3.19824 3.345 3.25658 2.19 3.37324L1 3.48991M4.20833 2.90047L4.33667 2.1363C4.43 1.58214 4.5 1.16797 5.48583 1.16797H7.01417C8 1.16797 8.07583 1.60547 8.16333 2.14214L8.29167 2.90047M10.2458 5.33276L9.86661 11.2069C9.80244 12.1228 9.74994 12.8344 8.12244 12.8344H4.37744C2.74994 12.8344 2.69744 12.1228 2.63328 11.2069L2.25411 5.33276M5.27588 9.6263H7.21838M4.79167 7.29297H7.70833"
        stroke={errorTextColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setGeneralError(""); // Clear general error on input change
    setIsDirty(true); // Mark the form as dirty when a change is made

    // Real-time date validation
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors, [name]: "" };
      if (name === "startDate" || name === "endDate") {
        const newStartDate = name === "startDate" ? value : formData.startDate;
        const newEndDate = name === "endDate" ? value : formData.endDate;
        if (newStartDate && newEndDate && newStartDate > newEndDate) {
          updatedErrors.endDate = t("Advertisement.endDateBeforeStartDate");
        }
      }
      return updatedErrors;
    });
  };

  useEffect(() => {
    const fetchAdvertisement = async () => {
      if (mode1 === "update" && adId) {
        try {
          const advertisementData = await getAdvertisementsById(adId);
          if (advertisementData) {
            setAdvertisement(advertisementData);
            setSelectedMachines(advertisementData.vendingMachineIds || []);

            const addData = {
              name: advertisementData.name || "",
              startDate: advertisementData.startDate || "",
              endDate: advertisementData.endDate || "",
              vendingMachineIds: advertisementData.vendingMachineIds || [],
              videoUploads: advertisementData.videoUploads || [],
            };
            // Update formData after fetching advertisement data
            setFormData(addData);
            setInitialFormState(addData);

            // Update video uploads only if `videoUploads` exist
            if (advertisementData.videoUploads) {
              const updatedVideoUploads = {
                vertical: { file: null, progress: 0, url: null },
                horizontal: { file: null, progress: 0, url: null },
                small: { file: null, progress: 0, url: null },
              };

              // Merge `videoUploads` with `videoUrls`
              advertisementData.videoUploads.forEach((upload, index) => {
                const screenType = upload.screenType?.toLowerCase();
                if (updatedVideoUploads[screenType]) {
                  updatedVideoUploads[screenType] = {
                    ...updatedVideoUploads[screenType],
                    file: upload.videoFile || null,
                    url: advertisementData.videoUrls?.[index] || null, // Assign the correct URL
                  };
                }
              });

              // console.log(updatedVideoUploads);

              setVideoUploads(updatedVideoUploads);
            }
          }
        } catch (error) {
          console.error(t("advertisement.errorFetchingData"), error);
        }
      }
    };

    const fetchLocations = async () => {
      try {
        const data = await getMachineLocations(); // Fetch locations from backend
        setLocations(data);
        setFilteredLocations(data); // Initial filtered locations
        if (advertisement?.vendingMachineIds)
          setSelectedMachines(advertisement?.vendingMachineIds);
      } catch (error) {
        console.error(t("advertisement.errorFetchingLocations"), error);
      }
    };
    fetchAdvertisement();
    fetchLocations();
  }, [mode1, adId]); // Dependencies added

  const handleToggleMachine = (machineId) => {
    setSelectedMachines((prev) =>
      prev.includes(machineId)
        ? prev.filter((id) => id !== machineId)
        : [...prev, machineId],
    );
  };

 const handleSelectAll = (checked) => {
  if (checked) {
    const allMachineIds = filteredLocations.flatMap((loc) =>
      (loc.machines || []).map((machine) => machine.machineId),
    );

    setSelectedMachines(allMachineIds);
  } else {
    setSelectedMachines([]);
  }
};

  const handleSearch = (event) => {
    const query = (event.target.value || "").toLowerCase();

    setSearchQuery(query);

    const filtered = locations.filter((loc) => {
      const city = (loc.city || "").toLowerCase();

      const machineMatch = (loc.machines || []).some((machine) => {
        const machineText =
          `${machine.machineNo || ""} ${machine.street || ""}`.toLowerCase();
        return machineText.includes(query);
      });

      return city.includes(query) || machineMatch;
    });

    setFilteredLocations(filtered);
  };

 const allMachines = filteredLocations.flatMap((loc) => loc.machines || []);

const isAllSelected =
  allMachines.length > 0 &&
  allMachines.every((machine) => selectedMachines.includes(machine.machineId));

  const handleDeleteClick = (row) => {
    setIsDeletePopupOpen(true);
  };

  const handleCloseDeletePopup = () => {
    setIsDeletePopupOpen(false);
  };

  const handleConfirmDelete = async () => {
    // console.log("adId", adId);
    if (!adId) return;
    // console.log("adId", adId);

    try {
      setIsLoading(true);
      await deleteAdvertisement(adId); // Call the delete API
      setSuccessMessage(t("advertisement.successMessage2"));
      setSuccessNotification(true);
      setIsDeletePopupOpen(false);
      setTimeout(() => {
        navigate(ROUTES.ADVERTISEMENTS);
      }, 3000); // 3-second delay
    } catch (error) {
      // setErrorMessage(`Failed to delete Product.`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackClick = () => {
    if (isDirty) {
      setIsModalOpen(true); // Open the modal only if the form is modified
    } else {
      navigate(ROUTES.ADVERTISEMENTS);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false); // Close the modal
  };

  const handleSaveChanges = () => {
    setIsModalOpen(false); // Close the modal after saving
    handleSubmit();
  };

  const handleDiscardChanges = () => {
    setIsModalOpen(false); // Close the modal after discarding
    navigate(ROUTES.ADVERTISEMENTS);
  };

  const validate = () => {
    setErrors({}); // Clear errors on input change
    let tempErrors = {};

    if (!formData.name?.trim()) {
      tempErrors.name = t("Advertisement.nameRequired");
    } else if (formData.name.trim().length < 2) {
      tempErrors.name = t("coupons.nameMinLength");
      setGeneralError(t("coupons.nameMinLength"));
    }
    if (!selectedMachines || selectedMachines.length === 0) {
      tempErrors.machine = t("Advertisement.selectonemachine");
    }

    // Check if at least one video is uploaded
    const videoFileUploaded = ["vertical", "horizontal", "small"].some(
      (type) => videoUploads[type]?.url,
    );
    const videoFileUploaded1 = ["vertical", "horizontal", "small"].some(
      (type) => videoUploads[type]?.file,
    );
    if (!videoFileUploaded && !videoFileUploaded1) {
      tempErrors.video = t("Advertisement.onevideomust");
    }

    // Date validation
    if (!formData.startDate) {
      tempErrors.startDate = t("Advertisement.startDateRequired");
    }
    if (!formData.endDate) {
      tempErrors.endDate = t("Advertisement.endDateRequired");
    }
    if (
      formData.startDate &&
      formData.endDate &&
      formData.startDate > formData.endDate
    ) {
      tempErrors.endDate = t("Advertisement.endDateBeforeStartDate");
    }

    setErrors(tempErrors);
    // console.log(tempErrors);

    return Object.keys(tempErrors).length === 0;
  };

  useEffect(() => {
    if (Object.keys(errors).length > 0) validate();
  }, [i18n.language]);

  const handleSubmit = async () => {
    if (!validate()) return;
    setIsLoading(true);
    const advertisementData = {
      id: advertisement?.id || 1,
      name: formData.name,
      startDate: formData.startDate || null,
      endDate: formData.endDate || null,
      vendingMachineIds: selectedMachines,
    };
    const videoUploadsArray = [];
    ["vertical", "horizontal", "small"].forEach((type) => {
      const videoFile = videoUploads[type]?.file;
      if (videoFile) {
        videoUploadsArray.push({ screenType: type });
      }
    });

    if (videoUploadsArray.length > 0) {
      advertisementData.videoUploads = videoUploadsArray;
    }
    const formDataToSend = new FormData();
    formDataToSend.append("advertisement", JSON.stringify(advertisementData));

    if (videoUploads) {
      ["vertical", "horizontal", "small"].forEach((type) => {
        const file = videoUploads[type]?.file;
        if (file) {
          formDataToSend.append(`videos`, file); // Append video file
          // console.log(`Appending file for ${type}:`, file);
        }
      });
    }
    try {
      // console.log("going", mode1);

      if (mode1 === "update") {
        await updateAdvertisement(advertisement.id, formDataToSend);
      } else {
        await addAdvertisement(formDataToSend);
      }
      setSuccessMessage(
        mode1 === "update"
          ? t("advertisement.successMessage1")
          : t("advertisement.successMessage"),
      );
      setSuccessNotification(true);
      setFormData({
        name: "",
        startDate: "",
        endDate: "",
        vendingMachineIds: [],
        videoUploads: [],
      });
      setVideoUploads({
        vertical: { file: null, progress: 0 },
        horizontal: { file: null, progress: 0 },
        small: { file: null, progress: 0 },
      });
      setSelectedMachines([]);
      setTimeout(() => {
        navigate(ROUTES.ADVERTISEMENTS);
      }, 3000); // 3-second delay
    } catch (error) {
      console.error("Advertisement Save Error:", error);

      const responseData = error?.response?.data;

      const backendMessage =
        typeof responseData === "string"
          ? responseData
          : responseData?.detail ||
            responseData?.message ||
            responseData?.error ||
            "";

      const normalizedMessage = String(backendMessage).toLowerCase();

      if (
        normalizedMessage.includes("already scheduled or live") ||
        normalizedMessage.includes("specified date range")
      ) {
        setToastMessage(t("advertisement.machineDateConflict"));
      } else if (normalizedMessage.includes("already exists")) {
        setToastMessage(t("advertisement.nameAlreadyExists"));
      } else {
        setToastMessage(t("advertisement.errorSaving"));
      }

      setOpen1(true);
    } finally {
      setIsLoading(false);
    }
  };


const handleFileUpload = (event, screenType) => {
  const file = event.target.files?.[0];
  if (!file) return;

  // 1. Validate file extension and MIME type
const extension = file.name.split(".").pop()?.toLowerCase();
const isValidType = extension === "mp4" && file.type === "video/mp4";
  if (!isValidType) {
    setToastMessage(
      t("advertisement.invalidVideoType", {
  defaultValue: "Only .mp4 video files are supported.",
})
     
    );
    setOpen1(true);
    event.target.value = "";
    return;
  }

  // 2. Validate maximum file size (50 MB)
 const maxSize = 50 * 1000 * 1000; // 50,000,000 bytes

if (file.size > maxSize) {
  setToastMessage(
    t("advertisement.fileSizeExceeded", {
      defaultValue: "Maximum file size is 50 MB.",
    })
  );
  setOpen1(true);
  event.target.value = "";
  return;
}

  // 3. Validate video dimensions and aspect ratio
  const video = document.createElement("video");
  const videoUrl = URL.createObjectURL(file);

  video.preload = "metadata";
  video.src = videoUrl;

  video.onloadedmetadata = () => {
    const { videoWidth, videoHeight } = video;
    URL.revokeObjectURL(videoUrl);

    const is1080x1920 =
      videoWidth === 1080 && videoHeight === 1920;

    // Allow other resolutions only if their ratio is 9:16
    const isNineSixteen =
      videoHeight > 0 &&
      Math.abs(videoWidth / videoHeight - 9 / 16) < 0.001;

    if (!is1080x1920 && !isNineSixteen) {
      setToastMessage(
        t("advertisement.invalidVideoResolution", {
          defaultValue:
            "Please upload a video with a 9:16 aspect ratio, such as 1080 × 1920.",
        })
      );
      setOpen1(true);
      event.target.value = "";
      return;
    }

    // 4. Accept the validated video
    setVideoUploads((prev) => ({
      ...prev,
      [screenType]: {
        ...prev[screenType],
        file,
        progress: 100,
      },
    }));

    setIsDirty(true);
    setErrors((prev) => ({ ...prev, video: "" }));
  };

  video.onerror = () => {
    URL.revokeObjectURL(videoUrl);

    setToastMessage(
      t("advertisement.invalidVideoFile", {
        defaultValue: "Unable to read this video. Please upload a valid video.",
      })
    );
    setOpen1(true);
    event.target.value = "";
  };
};

  const handleDeleteFile = (screenType) => {
    setVideoUploads((prev) => ({
      ...prev,
      [screenType]: { file: null, progress: 0 },
    }));
  };

  return (
    <div className="main-container">
      {isLoading && <LoadingAnimation />}
      {/* Back Button and Title */}
      <Box sx={{ display: "flex", width: "100%", alignItems: "center" }}>
        <IconButton
          className="westicons"
          sx={{
            color: blueColor,
            backgroundColor: backgroundCard,
            padding: "0.6rem",
            borderRadius: "50%",
            marginRight: "1rem",
            "&:hover": { backgroundColor: backgroundCard },
          }}
          onClick={handleBackClick}
        >
          <WestIcon fontSize="small" />
        </IconButton>
        <h2 className="addmachine-text-heading">
          {advertisement?.id
            ? t("advertisement.editAdvertisement")
            : t("advertisement.newAdvertisement")}
        </h2>
      </Box>

      <Box
        sx={{
          background: backgroundCard,
          p: 5,
          margin: "20px 0px",
          borderRadius: "12px",
        }}
      >
        <div className="card-border-sec advertisement_model_sec">
          <Grid container spacing={10} className="leftgrid">
            {/* Left Section */}
            <Grid item xs={12} md={6}>
              {/* Name */}
              <p
                className="label-text-sec"
                style={{
                  color: errors.name ? errorTextColor : textColor,
                }}
              >
                {" "}
                {t("Advertisement.NameofAdvertisement")} *
              </p>
              <Box
                sx={{
                  border: "none",
                  borderRadius: "8px",
                  backgroundColor: inputBoxColor,
                  padding: "0.5rem 1rem",
                }}
              >
                <InputBase
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  fullWidth
                  sx={{
                    fontSize: "14px",
                  }}
                />
              </Box>
              {generalError && (
                <Typography
                  sx={{
                    color: errorTextColor,
                    fontSize: "12px",
                    mt: "4px",
                  }}
                >
                  {generalError}
                </Typography>
              )}
              {/*{errors.name && (
                                <Typography sx={{ color: errorTextColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.name}
                                </Typography>
                            )} */}

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  {/* From Date */}
                  <p
                    className="label-text-sec"
                    style={{
                      color: errors.startDate ? errorTextColor : textColor,
                    }}
                  >
                    {t("Advertisement.From")}
                  </p>
                  <Box
                    sx={{
                      position: "relative",
                      backgroundColor: inputBoxColor,
                      borderRadius: "8px",
                      padding: "0.5rem 1rem",
                    }}
                  >
                    <InputBase
                      type="date"
                      name="startDate"
                      value={formData.startDate}
                      onChange={handleChange}
                      fullWidth
                      inputProps={{
                        min: today,
                      }}
                      sx={{
                        fontSize: "14px",
                        "&::placeholder": {
                          color: "#9CA3AF",
                        },
                      }}
                      onClick={showDatePicker}
                    />
                    <CalendarToday
                      sx={{
                        fontSize: "14px",
                        position: "absolute",
                        top: 15,
                        right: 17,
                        opacity: mode === "dark" ? 100 : 0, // Change color based on theme
                        color: mode === "dark" ? "#fff" : "#000", // Change color based on theme
                        pointerEvents: "none",
                      }}
                    />
                  </Box>
                  {/*{errors.startDate && (
                    <Typography
                      sx={{
                        color: errorTextColor,
                        fontSize: "12px",
                        marginTop: "2px",
                      }}
                    >
                      {errors.startDate}
                    </Typography>
                  )} */}
                </Grid>
                <Grid item xs={12} md={6} className="todate">
                  {/* To Date */}
                  <p
                    className="label-text-sec"
                    style={{
                      color: errors.endDate ? errorTextColor : textColor,
                    }}
                  >
                    {t("Advertisement.to")}
                  </p>
                  <Box
                    sx={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: inputBoxColor,
                      borderRadius: "8px",
                      padding: "0.5rem 1rem",
                    }}
                  >
                    <InputBase
                      type="date"
                      name="endDate"
                      value={formData.endDate}
                      onChange={handleChange}
                      fullWidth
                      inputProps={{ min: formData.startDate || today }}
                      sx={{
                        fontSize: "14px",
                        "&::placeholder": {
                          color: "#9CA3AF",
                        },
                      }}
                      onClick={showDatePicker}
                    />
                    <CalendarToday
                      sx={{
                        fontSize: "14px",
                        position: "absolute",
                        top: 15,
                        right: 17,
                        opacity: mode === "dark" ? 100 : 0, // Change color based on theme
                        color: mode === "dark" ? "#fff" : "#000", // Change color based on theme
                        pointerEvents: "none",
                      }}
                    />
                  </Box>
                  {/* {errors.endDate && (
                    <Typography
                      sx={{
                        color: errorTextColor,
                        fontSize: "12px",
                        marginTop: "2px",
                      }}
                    >
                      {errors.endDate}
                    </Typography>
                  )} */}
                </Grid>
              </Grid>

              <p
                style={{
                  marginTop: "2rem",
                  color: errors.machine ? errorTextColor : textColor,
                }}
                className="label-text-sec"
              >
                {t("Advertisement.SelectLocations")} *
              </p>
              <Box
                sx={{
                  background: backgroundCard,
                  border: `1px solid ${cardBorderColor40}`,
                  borderRadius: "10px",
                  p: 2,
                  mt: 2,
                  width: "100%",
                  maxWidth: "300px",
                  // maxHeight: "500px",
                  overflow: "auto",
                }}
              >
                {/* Search Bar */}
                <TextField
                  placeholder={t("membershipCards.search")}
                  value={searchQuery}
                  onChange={handleSearch}
                  style={{
                    borderRadius: "24px",
                    background: inputBoxColor,
                    width: "100%",
                    marginBottom: 10,
                  }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "none", // Removes the border from the outline
                      },
                    },
                  }}
                />
                <Box
                  sx={{
                    overflow: "auto",
                    maxHeight: "500px",
                    pr: 0.5,
                    // Custom scrollbar on the scrolling element; !important beats Sidebar.css globals
                    "&::-webkit-scrollbar": {
                      width: "10px !important",
                      height: "10px !important",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: scroll1,
                      borderRadius: "10px",
                      border: `1px solid ${scroll}`,
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: scroll,
                      borderRadius: "10px",
                      border: "3px solid transparent",
                      backgroundClip: "padding-box",
                      "&:hover": {
                        backgroundColor: scroll,
                      },
                    },
                  }}
                >
                  {/* Select All */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        className="checks"
                        checked={isAllSelected}
                        onChange={(e) => handleSelectAll(e.target.checked)}
                      />
                    }
                    label={t("sales_analytics.SelectAll")}
                    sx={{ color: textColor, mb: 1 }}
                  />

                  {/* Locations and Machines */}
                  {filteredLocations
                    .filter((loc) => loc.machines && loc.machines.length > 0)
                    .map((location, index) => (
                      <Box key={index}>
                        {/* Location Name */}
                        <p
                          className="popup-text margin-zero"
                          style={{
                            padding: "15px 0px 5px",
                            margin: 0,
                            borderTop: `0.5px solid ${dividerColor}`,
                          }}
                        >
                          {location.city}
                        </p>

                        {/* Machines */}
                        {location.machines.map((machine) => (
                          <FormControlLabel
                            classeName="location-right"
                            key={machine.machineId}
                            control={
                              <Checkbox
                                className="add-machine margin-zero "
                                checked={selectedMachines.includes(
                                  machine.machineId,
                                )}
                                onChange={() =>
                                  handleToggleMachine(machine.machineId)
                                }
                              />
                            }
                            label={`${machine.location} – ${machine.machineNo}`}
                            className="add-machine margin-zero "
                            sx={{ color: textColor, display: "block" }}
                          />
                        ))}
                      </Box>
                    ))}
                </Box>
              </Box>
              {/*{errors.machine && (
                <Typography
                  sx={{
                    color: errorTextColor,
                    fontSize: "12px",
                    marginTop: "2px",
                  }}
                >
                  {errors.machine}
                </Typography>
              )}*/}
            </Grid>

            {/* Right Section */}
            <Grid item xs={12} md={6} className="addfile">
              <p
                className="label-text-sec"
                style={{ color: errors.video ? errorTextColor : textColor }}
              >
                {t("Advertisement.AddFiles")} *
              </p>
              {/* {["vertical", "horizontal"].map((type) => ( */}
              {["vertical"].map((type) => (
                <Box
                  key={type}
                  sx={{
                    marginBottom: 4,
                    borderRadius: "12px",
                    padding: 2,
                    backgroundColor: inputBoxColor,
                    border: "2px dashed #bbb",
                    width:
                      type === "horizontal"
                        ? "100%"
                        : isMobile
                          ? "100%"
                          : "350px",
                    height: type === "horizontal" ? "390px" : "540px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "1rem",
                      mt: 1,
                      mb: 2,
                    }}
                  >
                    <p
                      className="machine-name-text4 machine-name-text"
                      style={{ margin: "0px" }}
                    >{`${t("Advertisement.for")} ${type === "vertical" ? t("Advertisement.vertical") : t("Advertisement.horizontal")} ${t("Advertisement.Screens")}`}</p>
                    <Box sx={{ textAlign: "right" }}>
                      <p
                        className="popup-text screennumber"
                        style={{ margin: "0px" }}
                      >
                        {type === "vertical"
                          ? "1080 x 1920"
                          : type === "horizontal"
                            ? "1920 x 1080"
                            : "1440 x 1020"}
                      </p>
                      <p
                        className="label-text-sec screennumbers"
                        style={{ margin: "5px 0px 0px", color: textColor }}
                      >
                        {type === "vertical"
                          ? `9:16 ${t("Advertisement.Ratio")}`
                          : type === "horizontal"
                            ? `16:9 ${t("Advertisement.Ratio")}`
                            : `16:10 ${t("Advertisement.Ratio")}`}
                      </p>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    {uploading ? (
                      <>
                        <LinearProgress
                          variant="determinate"
                          value={videoUploads[type].progress}
                          sx={{ width: "100%" }}
                        />
                        <Typography variant="body2">{`Uploading... ${videoUploads[type].progress}%`}</Typography>
                      </>
                    ) : (
                      <>
                        {videoUploads[type].file || videoUploads[type].url ? (
                          <video
                            controls
                            style={{
                              width: "100%",
                              height: type === "horizontal" ? "250px" : "400px",
                              objectFit: "cover",
                              borderRadius: "10px",
                            }}
                            onClick={() =>
                              document.getElementById(`upload-${type}`).click()
                            } // Trigger file input when video is clicked
                            loop
                          >
                            <source
                              src={
                                videoUploads[type].file
                                  ? URL.createObjectURL(videoUploads[type].file)
                                  : videoUploads[type].url
                              }
                              type={
                                videoUploads[type].file?.type || "video/mp4"
                              }
                            />
                            {t("Advertisement.Yourbrowser")}
                          </video>
                        ) : (
                          <label
                            className="clicklabel"
                            htmlFor={`upload-${type}`}
                            style={{
                              width: "100%",
                              padding: "1rem",
                              borderRadius: "8px",
                              textAlign: "center",
                              cursor: "pointer",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              "@media (max-width: 450px)": {
                                padding: "0.5rem !important",
                              },
                            }}
                          >
                            <CloudUploadIcon
                              sx={{ fontSize: 50, color: blueColor }}
                            />
                            <p
                              style={{
                                color: blueColor,
                                fontSize: "16px",
                                fontWeight: "500",
                                margin: "0px",
                              }}
                            >
                              {t("Advertisement.ClicktoUpload")}
                            </p>
                            <p
                              style={{
                                color: textColor,
                                fontSize: "14px",
                                margin: "5px 0px 4px",
                              }}
                            >
                              {t("Advertisement.Maxfilesize")}
                            </p>
                            <p
                              style={{
                                color: textColor,
                                fontSize: "12px",
                                margin: "2px 0px",
                              }}
                            >
                              {t("Advertisement.Onlysupport")}
                              {type === "vertical"
                                ? ` 9:16 ${t("Advertisement.Resolution")} or 1080x1920 ${t("Advertisement.Resolution")}`
                                : ` 16:9 ${t("Advertisement.Resolution")} or 1920x1080 ${t("Advertisement.Resolution")}`}
                            </p>
                            <input
                              id={`upload-${type}`}
                              type="file"
                              accept=".mp4,video/mp4"
                              style={{ display: "none" }}
                              onChange={(e) => handleFileUpload(e, type)}
                            />
                          </label>
                        )}
                      </>
                    )}
                  </Box>

                  <Box></Box>

                  {videoUploads[type].file || videoUploads[type].url ? (
                    <Box style={{ textAlign: "right" }}>
                      <IconButton
                        onClick={() => handleDeleteFile(type)}
                        sx={{ marginTop: 1, padding: "0px" }}
                      >
                        <CustomDeleteIcon />
                      </IconButton>
                    </Box>
                  ) : null}
                </Box>
              ))}

              {/*{errors.video && (
                <Typography
                  sx={{
                    color: errorTextColor,
                    fontSize: "12px",
                    marginTop: "2px",
                  }}
                >
                  {errors.video}
                </Typography>
              )} */}
            </Grid>
          </Grid>
        </div>

        {/* Save Button */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "1vw" }}>
          {mode1 === "update" && adId && (
            <button
              type="button"
              onClick={handleDeleteClick}
              style={{ color: errorTextColor, borderColor: errorTextColor }}
              className="cancel-btn"
            >
              {t("membershipCards.delete")}
            </button>
          )}
          <button
            type="button"
            onClick={handleSubmit}
            style={{ background: blueColor }}
            className="save-btn"
          >
            {t("membershipCards.save")}
          </button>
        </Box>
      </Box>

      {/* Render the Modal */}
      <ConfirmationModal
        open={isModalOpen}
        onClose={handleModalClose}
        onSave={handleSaveChanges}
        onDiscard={handleDiscardChanges}
      />

      {/* Use Notification Component */}
      <SuccessNotification
        open={successNotification}
        message={successMessage}
        severity="success"
        onClose={() => setSuccessNotification(false)}
      />
      <Snackbar
        open={open1}
        autoHideDuration={4000} // Auto hide after 3 seconds
        onClose={() => setOpen1(false)} // Close the Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }} // Position the Snackbar at the top center
      >
        <Alert
          onClose={() => setOpen1(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {toastMessage}
        </Alert>
      </Snackbar>

      {/* Delete Confirmation Popup */}
      <DeleteConfirmationPopup
        open={isDeletePopupOpen}
        onClose={handleCloseDeletePopup}
        heading={t("Advertisement.deleteConfirmHeading")}
        message={t("Advertisement.deleteConfirmMessage")}
        onConfirm={handleConfirmDelete}
        itemName={`(${adId})`}
        // errorMessage={errorMessage}
      />
    </div>
  );
}

export default AdvertisementModal;
